import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full background-orange-lighten-5 py-2 px-5 gap-4 grid grid-cols-4 items-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", { class: "color-primary font-bold text-xs sm:text-base" }, "Total Pendapatan Jadwal")
], -1)
const _hoisted_3 = { class: "col-span-2 md:col-span-1" }
const _hoisted_4 = { class: "color-primary font-bold text-sm sm:text-base" }
const _hoisted_5 = { style: {} }
const _hoisted_6 = { class: "color-primary font-bold text-sm sm:text-base" }
const _hoisted_7 = { class: "w-full background-grey-lighten-5 py-2 px-5 gap-4 grid grid-cols-4 items-center" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { style: {} }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold text-sm sm:text-base" }, "Total Yang Diterima")
], -1)
const _hoisted_9 = { class: "col-span-3 md:col-span-2" }
const _hoisted_10 = {
  key: 1,
  class: "flex justify-between bg-white rounded-lg py-1 px-2 w-full",
  style: {"border":"1px solid #CFD8DC"}
}
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-bold text-sm sm:text-base" }, "Rp. ", -1)
const _hoisted_12 = { class: "color-blue-grey font-bold text-sm sm:text-base" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxScrolling = _resolveComponent("DxScrolling")
  const _component_DxColumn = _resolveComponent("DxColumn")
  const _component_DxGroupPanel = _resolveComponent("DxGroupPanel")
  const _component_DxGrouping = _resolveComponent("DxGrouping")
  const _component_DxPaging = _resolveComponent("DxPaging")
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Textarea = _resolveComponent("Textarea")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_DxDataGrid, {
      class: "data-grid-table-finished",
      "allow-column-reordering": false,
      "show-column-lines": false,
      "show-row-lines": true,
      "show-borders": true,
      "row-alternation-enabled": true,
      "allow-column-resizing": false,
      "word-wrap-enabled": true,
      "data-source": _ctx.dataSource,
      "key-expr": "Id"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxScrolling, { mode: "virtual" }),
        _createVNode(_component_DxColumn, {
          "group-index": 0,
          "data-field": "Agent",
          width: 250
        }),
        _createVNode(_component_DxColumn, {
          "group-index": 1,
          "data-field": "Manifest",
          width: 250
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Resi",
          caption: "No. Resi",
          width: 250,
          "css-class": "cell-highlighted"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Tunai",
          caption: "Tunai"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NonTunai",
          caption: "Non-Tunai"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Keterangan",
          caption: "Keterangan"
        }),
        _createVNode(_component_DxGroupPanel, { visible: true }),
        _createVNode(_component_DxGrouping, { "auto-expand-all": _ctx.autoExpandAll }, null, 8, ["auto-expand-all"]),
        _createVNode(_component_DxPaging, {
          "page-size": 10,
          enabled: false
        }),
        _createVNode(_component_DxSearchPanel, { visible: false })
      ]),
      _: 1
    }, 8, ["data-source"]),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode("p", _hoisted_4, _toDisplayString(`Rp. ${new Number(_ctx.sumTunai).toLocaleString('id-ID')}`), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("p", _hoisted_6, _toDisplayString(`Rp. ${new Number(_ctx.sumNonTunai).toLocaleString('id-ID')}`), 1)
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode("div", _hoisted_9, [
          (!_ctx.dataHeader.IsClose)
            ? (_openBlock(), _createBlock(_component_InputNumber, {
                key: 0,
                id: "totalReceivedId",
                class: "input-primary rounded-lg w-full",
                modelValue: _ctx.totalReceived,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.totalReceived = $event)),
                modelModifiers: { lazy: true },
                mode: "currency",
                currency: "IDR",
                currencyDisplay: "code",
                locale: "id-ID"
              }, null, 8, ["modelValue"]))
            : (_openBlock(), _createBlock("div", _hoisted_10, [
                _hoisted_11,
                _createVNode("p", _hoisted_12, _toDisplayString(`${new Number(_ctx.totalReceived).toLocaleString('id-ID')}`), 1)
              ]))
        ])
      ])
    ]),
    _createVNode("div", null, [
      _createVNode(_component_Textarea, {
        autoResize: true,
        id: "descriptionTableFinishedId",
        modelValue: _ctx.descriptionTableFinished,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.descriptionTableFinished = $event)),
        rows: "2",
        class: "md:w-1/2 w-full rounded-lg input-primary mb-0 mt-4",
        placeholder: "Keterangan",
        disabled: _ctx.dataHeader.IsClose
      }, null, 8, ["modelValue", "disabled"])
    ])
  ]))
}